import src from "IMAGE";
export default { src, width: 2962, height: 783, blurWidth: 0, blurHeight: 0};
